import styled from "styled-components";

// Contêiner das páginas administrativas novas (Painel, Usuários, Pedidos).
//
// Não usa o `Main`/`.content` de ui/modules/styled.js de propósito: aquele
// `.content button` pinta TODO botão da página de verde e joga margens
// negativas (feito para o botão "Adicionar" dos cards antigos). Aqui os botões
// de cada bloco têm o próprio estilo.
export const Pagina = styled.main`
  width: 100%;
  min-width: 0;
  height: 100vh;
  overflow-y: auto;
  padding: 48px 56px 64px;
  background: #fff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 796px){
    padding: 28px 14px 48px;
  }
`;

const Titulo = styled.header`
  h2{ margin: 0; font-size: 24px; font-weight: 700; }
  p{ margin: 4px 0 0; font-size: 14px; color: #4D4F50; }
`;

export function Cabecalho({ titulo, descricao }) {
  return (
    <Titulo>
      <h2>{titulo}</h2>
      {descricao && <p>{descricao}</p>}
    </Titulo>
  );
}
